import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ac1d198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input-section" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-title" }, "用户名", -1))
const _hoisted_4 = { class: "input-line" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-title" }, "密码", -1))
const _hoisted_6 = { class: "input-line" }
const _hoisted_7 = { class: "error-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guanbi" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode("登录")
const _hoisted_10 = { class: "login-last" }
const _hoisted_11 = { class: "left" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("记住密码 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_el_form, { model: _ctx.loginParams }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.loginParams.userName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginParams.userName) = $event)),
                modelModifiers: { trim: true },
                type: "text",
                placeholder: "账号",
                class: "input-password",
                autocomplete: "false",
                size: "large",
                maxlength: "16",
                onKeyup: _withKeys(_ctx.doLogin, ["enter"]),
                id: "login-userName"
              }, null, 8, ["modelValue", "onKeyup"])
            ]),
            _: 1
          })
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.loginParams.password,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginParams.password) = $event)),
                modelModifiers: { trim: true },
                type: _ctx.passwordType,
                placeholder: "密码",
                class: "input-password",
                autocomplete: "false",
                maxlength: "16",
                onKeyup: _withKeys(_ctx.doLogin, ["enter"]),
                id: "login-password",
                size: "large"
              }, {
                suffix: _withCtx(() => [
                  _createElementVNode("span", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
                  }, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["iconfont icon-password", _ctx.showPassword ? 'icon-xianshikejian' : 'icon-yincangbukejian'])
                    }, null, 2)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "type", "onKeyup"])
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.errorText), 1)
        ], 512), [
          [_vShow, _ctx.errorText]
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            id: "login-btn",
            class: "login-btn",
            type: "primary",
            onClick: _ctx.doLogin,
            onKeyup: _withKeys(_ctx.doLogin, ["enter"])
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["onClick", "onKeyup"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_checkbox, {
              modelValue: _ctx.noLogin,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.noLogin) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}